/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostAgentOptimizationPathParams = NonNullable<operations['postAgentOptimization']['parameters']['path']>;

export type PostAgentOptimizationRequestBody = OperationRequestBodyContent<operations['postAgentOptimization']>;

export interface Input extends PostAgentOptimizationPathParams {
  apiVersion?: string;
  body: PostAgentOptimizationRequestBody;
}

export async function postAgentOptimization(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/agent-optimizations', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
